export const exportToCSV = (data, headers, filename) => {
  if (!data || data.length === 0) {
    alert("Nenhum dado para exportar!");
    return;
  }

  // Cria o conteúdo CSV
  const csvContent = [headers, ...data]
    .map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(","))
    .join("\n");

  // Adiciona BOM para UTF-8 (garante acentos corretos no Excel)
  const BOM = "\uFEFF";
  const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
  
  // Cria link para download
  const link = document.createElement("a");
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${filename}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // Limpa a memória
  }
};

export const generateSafeFilename = (name, prefix = "", includeDate = true) => {
  const safeName = name.replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, "_");
  const date = includeDate ? `_${new Date().toISOString().split('T')[0]}` : "";
  const prefixStr = prefix ? `${prefix}_` : "";
  
  return `${prefixStr}${safeName}${date}`;
};

export const formatCurrency = (value) => {
  return `R$ ${Number(value).toFixed(2)}`;
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Valor numérico com vírgula decimal (padrão pt-BR) para planilhas
export const formatarValorCSV = (value) => {
  return Number(value || 0).toFixed(2).replace(".", ",");
};
